// R-162 §10.1 / WU-3.8 — list hook for /admin/queue-blocks.
//
// Thin wrapper around `queueBlocksApi.list()` mirroring the conventions of
// `useCustomCounters` (load on mount, expose `refetch`).
import { useCallback, useEffect, useState } from "react";
import { queueBlocksApi, type QueueBlockRecord } from "../api/client";

export function useQueueBlocks() {
  const [blocks, setBlocks] = useState<QueueBlockRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const result = await queueBlocksApi.list();
      setBlocks(result.blocks);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return { blocks, loading, error, refetch };
}
